// extracted by mini-css-extract-plugin
export default {"lightPanel":"SecondaryTaskGrid_lightPanel__hPKZq","darkPanel":"SecondaryTaskGrid_darkPanel__U41o2"};